module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/badge/badge.component.scss
// module id = ./src/app/features/badge/badge.component.scss
// module chunks = main